/**
 * The per-asset event stream (ADR-63 section 39). An asset's history is an
 * append-only list of these, one row per thing that happened to it, so the
 * story survives every reassignment, move and repair. Ownership, custody and
 * status changes each leave one; assignment and kit events join the list in
 * later cuts. The set is closed so a reader can filter and a test can assert on
 * exactly what was written, never on prose.
 */

export const ASSET_EVENT_TYPES = [
  'CREATED',
  'UPDATED',
  'STATUS_CHANGED',
  'OWNER_CHANGED',
  'LOCATION_CHANGED',
  'CONDITION_CHANGED',
  'NOTE',
  'RETIRED',
  // Kit membership (Cut 2): the asset's own timeline shows it joining or
  // leaving a kit, so its history stays complete across kit swaps.
  'KIT_ADDED',
  'KIT_REMOVED',
  // Assignment (Cut 3): assigned to a tenant, and returned.
  'ASSIGNED',
  'RETURNED',
] as const;
export type AssetEventType = (typeof ASSET_EVENT_TYPES)[number];

/** Who caused an event. OPERATOR now; SYSTEM and AGENT are reserved for later cuts (a return workflow, the sweep). */
export const ASSET_ACTOR_TYPES = ['OPERATOR', 'SYSTEM', 'AGENT'] as const;
export type AssetActorType = (typeof ASSET_ACTOR_TYPES)[number];

export function isAssetEventType(v: unknown): v is AssetEventType {
  return typeof v === 'string' && (ASSET_EVENT_TYPES as readonly string[]).includes(v);
}
